import classNames from 'classnames';

const CheckIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const { className = '', ...attributes } = props;
  const classes = classNames('check-icon', className);

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      className={classes}
      {...attributes}
    >
      <path
        d="M27.241 5.217c0.293-0.293 0.768-0.293 1.061 0l1.768 1.768c0.293 0.293 0.293 0.768 0 1.061l-18.738 18.738c-0.293 0.293-0.768 0.293-1.061 0l-8.339-8.339c-0.293-0.293-0.293-0.768 0-1.061l1.768-1.768c0.293-0.293 0.768-0.293 1.061 0l6.041 6.041z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CheckIcon;
